import MessagesTable from './MessagesTable';

export default MessagesTable;
